var _path, _ellipse, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.325 14.22a2.166 2.166 0 0 1-1.429-.582l-2.64-2.542a1.089 1.089 0 0 0-1.5-.08L0 14.036v1.959c-.027.525.341.975.822 1.005h13.37c.533 0 1.066-.423 1.066-1.005v-5.136l-4.771 3.018c-.35.23-.753.35-1.163.344Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.132,
    cy: 7.92,
    rx: 1.066,
    ry: 1.165
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.777 2.07a.88.88 0 0 0-.653-.398L3.924.004a1.044 1.044 0 0 0-.726.212 1.248 1.248 0 0 0-.363.688L2.617 2.97h11.576c1.104.028 1.996.991 2.035 2.197v9.345c0-.053.217-.106.314-.212a.933.933 0 0 0 .315-.714l1.138-10.748a1.098 1.098 0 0 0-.218-.768Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.193 4.028H.897c-.532 0-.896.556-.896 1.138v7.545l3.197-2.541c.812-.658 1.934-.603 2.688.132l2.664 2.541c.402.373.976.426 1.43.133l5.279-3.362V5.166c-.037-.621-.497-1.112-1.066-1.138Zm-5.061 6.115c-1.124 0-2.035-.995-2.035-2.224 0-1.228.911-2.223 2.035-2.223 1.123 0 2.034.995 2.034 2.223 0 1.229-.91 2.224-2.034 2.224Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon_image.59554f7096c00ec09c2543d8fe220385.svg";
export { ForwardRef as ReactComponent };